import gql from 'graphql-tag';

export const createWalletMutation = gql`
  mutation ($orgId: ID!, $wallet: WalletInput!, $prems: [WalletPermissionInput]!) {
    createWallet(orgId: $orgId, wallet: $wallet, prems: $prems) {
      id
    }
  }
`;
